import { render, staticRenderFns } from "./Postgrado-add.vue?vue&type=template&id=2aaea15c"
import script from "./Postgrado-add.vue?vue&type=script&lang=js"
export * from "./Postgrado-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports